import { createContext, useContext, useReducer } from 'react';

import { IAuth } from '@/modules/auth/types';

import { authReducer, authTypes } from './reducer';
export enum IAuthTypes {
  login = 'LOG_IN',
  loginInvitation = 'LOG_IN_INVITATION',
  signup = 'SIGN_UP',
  loginOTP = 'LOGIN_OTP',
  resetPassword = 'RESET_PASSWORD',
  createPassword = 'CREATE_PASSWORD',
  forgotPassword = 'FORGOT_PASSWORD',
}
export type ISetType = <T extends InitialStateType['authType']>(
  ...args: Extract<InitialStateType, { type: T }> extends {
    authPayload: infer TPayload;
  }
    ? [authType: T, authPayload: TPayload]
    : [authType: T]
) => void;

export type InitialStateType =
  | {
      authType: IAuthTypes.login;
      authPayload: IAuth.ILoginTypeSchema;
    }
  | {
      authType: IAuthTypes.signup;
    }
  | {
      authType: IAuthTypes.loginOTP;
      authPayload: IAuth.ILoginTypeSchema;
    }
  | {
      authType: IAuthTypes.resetPassword;
    }
  | {
      authType: IAuthTypes.createPassword;
    }
  | {
      authType: IAuthTypes.forgotPassword;
      authPayload: IAuth.ILoginTypeSchema;
    };

const initialState: InitialStateType = {
  authType: IAuthTypes.login,
  authPayload: {
    loginType: 'phoneNumber',
    identifier: '',
    country: 'EG',
  },
};

const AuthContext = createContext<{
  state: InitialStateType;
  setAuthType: ISetType;
}>({
  state: initialState,
  setAuthType: () => {
    return;
  },
});

const AuthStatusProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  const setAuthType: ISetType = (authType, authPayload?) => {
    dispatch({
      type: authTypes.setAuthType,
      payload: {
        ...state,
        authType,
        ...(authType === IAuthTypes.loginOTP ||
        authType === IAuthTypes.resetPassword ||
        authType === IAuthTypes.login
          ? ({ authPayload } as { authPayload: IAuth.ILoginTypeSchema })
          : {}),
      } as InitialStateType,
    });
  };

  return (
    <AuthContext.Provider value={{ state, setAuthType }}>
      {children}
    </AuthContext.Provider>
  );
};
const useAuthContext = () => useContext(AuthContext);

export { AuthStatusProvider, useAuthContext };
